import React from "react";
import AwardSection from "../../components/hero/DevannaKamath";
export default function DevannaKamath() {
  return (
    <div>
      <AwardSection />
    </div>
  );
}
